export enum NewRelicEventType {
    // PageView name is used by New Relic browser monitoring
    CustomPageView = 'CustomPageView',
    DesignSystemAdoption = 'DesignSystemAdoption',
    LongTask = 'LongTask',
    MemoryInfo = 'MemoryInfo',
    Resource = 'Resource',
}
